import { MAX_MESSAGES_IN_STATE } from '../constants';

export const normalizeChatMessages = (messages = [], normalizeMessage = (message) => message) => {
  return messages.map((message) => normalizeMessage(message));
};

export const hasMessageById = (messages = [], messageId) => {
  return messages.some((message) => String(message?.id) === String(messageId));
};

export const prependUniqueMessages = (prevMessages = [], incomingMessages = []) => {
  const existingIds = new Set(prevMessages.map((message) => String(message?.id)));
  const preparedIncoming = incomingMessages.filter(
    (message) => !existingIds.has(String(message?.id)),
  );

  return [...preparedIncoming, ...prevMessages];
};

export const appendUniqueMessages = (prevMessages = [], incomingMessages = []) => {
  const existingIds = new Set(prevMessages.map((message) => String(message?.id)));
  const preparedIncoming = incomingMessages.filter(
    (message) => !existingIds.has(String(message?.id)),
  );

  return [...prevMessages, ...preparedIncoming];
};

export const replaceMessageById = (messages = [], messageId, nextMessage) => {
  return messages.map((message) =>
    String(message?.id) === String(messageId) ? nextMessage : message,
  );
};

export const removeMessageById = (messages = [], messageId) => {
  return messages.filter((message) => String(message?.id) !== String(messageId));
};

export const appendUploadedFileToMessage = (messages = [], messageId, file) => {
  return messages.map((message) =>
    String(message?.id) === String(messageId)
      ? {
        ...message,
        files: (message?.files ?? []).some((item) =>
          (!!item?.id && !!file?.id && String(item.id) === String(file.id)) ||
          (!!item?.path && !!file?.path && String(item.path) === String(file.path)) ||
          (!!(item?.original || item?.name) && !!(file?.original || file?.name) && String(item?.original || item?.name) === String(file?.original || file?.name)),
        )
          ? message?.files ?? []
          : [...(message?.files ?? []), file],
      }
      : message,
  );
};

export const getOldestMessageId = (messages = []) => {
  return messages?.[0]?.id ?? null;
};

export const getNewestMessageId = (messages = []) => {
  return messages?.[messages.length - 1]?.id ?? null;
};

export const trimMessagesWindow = (
  messages = [],
  {
    maxCount = MAX_MESSAGES_IN_STATE,
    mode = 'latest',
  } = {},
) => {
  if (messages.length <= maxCount) return messages;

  if (mode === 'prepend') {
    return messages.slice(0, maxCount);
  }

  if (mode === 'append') {
    return messages.slice(messages.length - maxCount);
  }

  return messages.slice(messages.length - maxCount);
};
